import { gql } from '@apollo/client';

export const CREATE_COMPANY = gql`
    mutation createCompany($company: CreateCompany!) {
        system {
            company {
                create(input: $company) {
                    id
                }
            }
        }
    }
`;
